import { render } from "./BusinessPlanPage.vue?vue&type=template&id=217de9ed"
import script from "./BusinessPlanPage.vue?vue&type=script&lang=js"
export * from "./BusinessPlanPage.vue?vue&type=script&lang=js"

import "./BusinessPlanPage.vue?vue&type=style&index=0&id=217de9ed&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__